import React from "react";
import { FormControl } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { setStateRegistry, setIeIndicator } from "@parts/person/personAdaptToCompany/actions";

class StateRegistry extends React.Component {
  constructor(props) {
    super(props);
    this._onChange = this._onChange.bind(this);
    this._set = this._set.bind(this);
    this._onChangeIeIndicator = this._onChangeIeIndicator.bind(this);
  }

  _onChange(e) {
    const text = e.target.value.replace(/\D/g, "");
    if (text.length < 21) {
      this.props.setStateRegistry(text);
    }
  }

  _set() {
    this.props.setStateRegistry("ISENTO");
  }

  _onChangeIeIndicator(e) {
    this.props.setIeIndicator(e.target.value);
  }

  render() {
    const { stateRegistry, ieIndicator, loading } = this.props;
    return (
      <div className="py-1 col-md-12 col-xs-12">
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <div style={{ justifyContent: "space-between" }} className="row col-12">
              <div>Inscrição Estadual (IE)</div>
              <div>{stateRegistry.length || 0}/20</div>
            </div>

            <FormControl
              placeholder="Informe aqui"
              disabled={loading}
              onChange={this._onChange}
              value={stateRegistry}
            />

            <button
              disabled={loading}
              onClick={this._set}
              className="btn btn-primary btn-sm d-block mb-2"
            >
              Isento de Inscrição Estadual
            </button>

            <a
              className="my-1 d-inline-block"
              href="https://dfe-portal.svrs.rs.gov.br/NFE/CCC"
              target="_blank"
              rel="noreferrer"
            >
              Não sei a Inscrição Estadual
            </a>
          </div>

          <div className="col-md-6 col-xs-12">
            <div className="row col-12">
              <div>Indicador de IE</div>
            </div>

            <select
              className="form-control"
              disabled={loading}
              value={ieIndicator}
              onChange={this._onChangeIeIndicator}
            >
              <option value="" disabled>Selecione...</option>
              <option value="1">1 - Contribuinte ICMS</option>
              <option value="2">2 - Contribuinte Isento</option>
              <option value="9">9 - Não Contribuinte</option>
            </select>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  stateRegistry: state.stateRegistry,
  ieIndicator: state.ieIndicator != null ? state.ieIndicator : "",
  loading: state.loading,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setStateRegistry, setIeIndicator }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StateRegistry);



// WEBPACK FOOTER //
// ./src/components/parts/person/personAdaptToCompany/stateRegistry/index.jsx